module.exports = __webpack_public_path__ + "static/3haedBatman-d5dde1da8b6d969b2a1d1503f43cd041.png";